module.exports = __webpack_public_path__ + "static/media/ownershipEcheqs.b2aaf634.svg";